module.exports = __webpack_public_path__ + "media/images/favicon-9795dfac.svg";